/*
 * @authors :Bin Mei
 * @description：  患者管理模块路由
 */
import validate from 'src/utils/validate';
const route = [
  {
    path: '/hospital/myinquiry',
    name: 'MyInquiry',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myInquiry'),
    auth: true,
    exact: true,
    title: '问诊记录',
  }, {
    path: '/hospital/mymentalConsult',
    name: 'MyMentalConsul',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myInquiry'),
    auth: true,
    exact: true,
    title: '咨询记录',
  }, {
    path: '/hospital/mymentalConsult/expired',
    name: 'MyMentalConsult',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myInquiry'),
    auth: true,
    exact: true,
    title: '咨询记录',
  }, {
    path: '/hospital/myinquiry/expired',
    name: 'MyInquiryExpired',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myInquiry'),
    auth: true,
    exact: true,
    title: '问诊记录',
  }, {
    path: '/hospital/myaddress',
    name: 'MyAddress',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myAddress'),
    auth: true,
    exact: true,
    title: '地址管理',
  }, {
    path: '/hospital/editaddress',
    name: 'EditAsddress',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myAddress/editAddress'),
    auth: true,
    exact: true,
    title: '地址管理',
  }, {
    path: '/hospital/mydoctor',
    name: 'MyDoctor',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myDoctor'),
    auth: true,
    exact: true,
    title: '我的医生',
  }, {
    path: '/hospital/mycoupon',
    name: 'couponExchange',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myCoupon/exchange'),
    auth: true,
    exact: true,
    title: '优惠券',
  },
  {
    path: '/hospital/mycoupon/history',
    name: 'couponHistory',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myCoupon'),
    auth: true,
    exact: true,
    title: '优惠券',
  }, {
    path: '/hospital/myorder',
    name: 'MyOrder',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myOrder/index'),
    auth: true,
    exact: true,
    title: '我的订单',
  }, {
    path: '/hospital/mypatients',
    name: 'MyPatients',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myPatients'),
    auth: true,
    exact: true,
    title: '健康档案',
  }, {
    path: '/hospital/myprescription',
    name: 'MyPrescription',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myPrescription'),
    auth: true,
    exact: true,
    title: '处方管理',
  }, {
    path: '/hospital/myprescription/expired',
    name: 'MyPrescriptionExpired',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myPrescription'),
    auth: true,
    exact: true,
    title: '处方管理',
  },
  // {
  //   path: "/hospital/myservpack",
  //   name: "Myservpack",
  //   component: () => import(/* webpackPrefetchPlaceHolder */ './myServpack'),
  //   auth: true,
  //   exact: true,
  //   title: "健康e家"
  // },
  {
    path: '/hospital/mycheckup',
    name: 'MyCheckup',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myCheckup'),
    auth: true,
    exact: true,
    title: '体检权益',
  }, {
    path: '/hospital/servpackdetail',
    name: 'Myservpack',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myServpack/detail'),
    auth: true,
    exact: true,
    title: '健康e家',
  }, {
    path: '/hospital/personalcenter',
    name: 'PersonalCenter',
    component: () => import(/* webpackPrefetchPlaceHolder */ './index'),
    auth: false,
    exact: true,
    title: () => validate.isFromRuiHua() ? '瑞华急速医疗服务卡' :'个人中心',
  }, {
    path: '/hospital/myrights',
    name: 'MyRights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '我的权益',
  },
  {
    path: '/hospital/expiredRights',
    name: 'ExpiredRights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/expiredRights'),
    auth: true,
    exact: true,
    realAuth: true,
    title: '失效权益',
  },
  {
    path: '/hospital/myrights/cancercheckappoint',
    name: 'CancerCheckAppoint',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/cancerCheckAppoint'),
    auth: true,
    exact: true,
    title: '防癌筛查关爱',
    realAuth: true,
  },
  {
    path: '/hospital/myrights/cancercheckappointOptimized',
    name: 'CancerCheckAppointOptimized',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/cancerCheckAppoint'),
    auth: true,
    exact: true,
    title: '防癌筛查关爱优选',
    realAuth: true,
  },
  {
    path: '/hospital/myrights/cantuse',
    name: 'CantUse',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/cantUse'),
    auth: true,
    exact: true,
    title: '我的权益',
  },
  {
    path: '/hospital/myrights/activeTrach',
    name: 'CantUse',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/activeTrach'),
    auth: true,
    exact: true,
    title: '我的权益',
  },
  {
    path: '/hospital/myrights/pupuguan',
    name: 'Pupuguan',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/pupuguan'),
    auth: true,
    exact: true,
    title: '噗噗管',
  },
  {
    path: '/hospital/myrights/feelingsecure',
    name: 'FeelingSecure',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/feelingsecure'),
    auth: true,
    exact: true,
    title: '众安心服务包',
  },
  {
    path:'/hospital/family-info',
    name:'familyInfo',
    component:() => import(/* webpackPrefetchPlaceHolder */'./family-info/list'),
    auth: true,
    exact: true,
    realAuth: true,
    title:'成员列表',
  },
  {
    path:'/hospital/myrights/familymember',
    name:'familyMember',
    component:() => import(/* webpackPrefetchPlaceHolder */'./myRights/familyMember'),
    auth: true,
    exact: true,
    realAuth: true,
    title:'选择家庭成员',
  },
  {
    path:'/hospital/myrights/drawrights',
    name:'familyMember',
    component:() => import(/* webpackPrefetchPlaceHolder */'./myRights/drawRights'),
    auth: true,
    exact: true,
    title:'权益查询',
  },
  {
    path:'/hospital/myrights/certification',
    name:'myrights/certification',
    component:() => import(/* webpackPrefetchPlaceHolder */'./rightCertificationBind'),
    auth: true,
    exact: true,
    title:'身份信息确认',
  },
  {
    path: '/hospital/myrights/leya',
    name: 'LeyaTeeth',
    component: () => import(/* webpackPrefetchPlaceHolder */ './leyaTeeth'),
    auth: true,
    exact: true,
    title: '乐牙齿科服务',
  },
  {
    path: '/hospital/myrights/qrcode/:vasCode',
    name: 'commonVasCode',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/qrcode'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/myrights/qrcode/:vasCode/service',
    name: 'commonVasCodeService',
    component: () => import(/* webpackPrefetchPlaceHolder */ './myRights/qrcode/service'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
  {
    path: '/hospital/setting',
    name: 'Setting',
    component: () => import(/* webpackPrefetchPlaceHolder */ './setting'),
    auth: true,
    exact: true,
    title: '设置',
  },
  {
    path: '/hospital/setting/deleteAccount',
    name: 'DestoryAccount',
    component: () => import(/* webpackPrefetchPlaceHolder */ './setting/deleteAccount'),
    auth: true,
    exact: true,
    title: '注销账号',
  },
];

export default route;
